module.exports = __webpack_public_path__ + "img/library.802b2731.svg";